import { render, staticRenderFns } from "./DataSingleCabinet.vue?vue&type=template&id=c40a9fbc&"
import script from "./DataSingleCabinet.vue?vue&type=script&lang=js&"
export * from "./DataSingleCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports